<template>
    <div id="header">
        <img alt="Life Quote logo" src="../assets/logo.png"/>
    </div>
</template>


<script>
export default {}
</script>